/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BpPilot } from '../models/bp-pilot';
import { checkDuplicate } from '../fn/pilot-controller/check-duplicate';
import { CheckDuplicate$Params } from '../fn/pilot-controller/check-duplicate';
import { create } from '../fn/pilot-controller/create';
import { Create$Params } from '../fn/pilot-controller/create';
import { CreatedPilotDetails } from '../models/created-pilot-details';
import { getActiveBpPilots } from '../fn/pilot-controller/get-active-bp-pilots';
import { GetActiveBpPilots$Params } from '../fn/pilot-controller/get-active-bp-pilots';
import { getBpPilots } from '../fn/pilot-controller/get-bp-pilots';
import { GetBpPilots$Params } from '../fn/pilot-controller/get-bp-pilots';
import { getPilot } from '../fn/pilot-controller/get-pilot';
import { GetPilot$Params } from '../fn/pilot-controller/get-pilot';
import { getPilots } from '../fn/pilot-controller/get-pilots';
import { GetPilots$Params } from '../fn/pilot-controller/get-pilots';
import { reactivatePilot } from '../fn/pilot-controller/reactivate-pilot';
import { ReactivatePilot$Params } from '../fn/pilot-controller/reactivate-pilot';
import { softDelete } from '../fn/pilot-controller/soft-delete';
import { SoftDelete$Params } from '../fn/pilot-controller/soft-delete';
import { update1 } from '../fn/pilot-controller/update-1';
import { Update1$Params } from '../fn/pilot-controller/update-1';

@Injectable({ providedIn: 'root' })
export class PilotControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getPilot()` */
  static readonly GetPilotPath = '/pilots/{pilotId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPilot()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPilot$Response(params: GetPilot$Params, context?: HttpContext): Observable<StrictHttpResponse<CreatedPilotDetails>> {
    return getPilot(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPilot$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPilot(params: GetPilot$Params, context?: HttpContext): Observable<CreatedPilotDetails> {
    return this.getPilot$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreatedPilotDetails>): CreatedPilotDetails => r.body)
    );
  }

  /** Path part for operation `update1()` */
  static readonly Update1Path = '/pilots/{pilotId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `update1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  update1$Response(params: Update1$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return update1(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `update1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  update1(params: Update1$Params, context?: HttpContext): Observable<void> {
    return this.update1$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `softDelete()` */
  static readonly SoftDeletePath = '/pilots/{pilotId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `softDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  softDelete$Response(params: SoftDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return softDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `softDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  softDelete(params: SoftDelete$Params, context?: HttpContext): Observable<void> {
    return this.softDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `reactivatePilot()` */
  static readonly ReactivatePilotPath = '/pilots/{pilotId}/reactivation';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reactivatePilot()` instead.
   *
   * This method doesn't expect any request body.
   */
  reactivatePilot$Response(params: ReactivatePilot$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return reactivatePilot(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reactivatePilot$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reactivatePilot(params: ReactivatePilot$Params, context?: HttpContext): Observable<void> {
    return this.reactivatePilot$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getPilots()` */
  static readonly GetPilotsPath = '/pilots';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPilots()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPilots$Response(params: GetPilots$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CreatedPilotDetails>>> {
    return getPilots(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPilots$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPilots(params: GetPilots$Params, context?: HttpContext): Observable<Array<CreatedPilotDetails>> {
    return this.getPilots$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CreatedPilotDetails>>): Array<CreatedPilotDetails> => r.body)
    );
  }

  /** Path part for operation `create()` */
  static readonly CreatePath = '/pilots';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `create()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create$Response(params: Create$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return create(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `create$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create(params: Create$Params, context?: HttpContext): Observable<void> {
    return this.create$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getBpPilots()` */
  static readonly GetBpPilotsPath = '/pilots/bp-pilots';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBpPilots()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getBpPilots$Response(params: GetBpPilots$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BpPilot>>> {
    return getBpPilots(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBpPilots$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getBpPilots(params: GetBpPilots$Params, context?: HttpContext): Observable<Array<BpPilot>> {
    return this.getBpPilots$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<BpPilot>>): Array<BpPilot> => r.body)
    );
  }

  /** Path part for operation `checkDuplicate()` */
  static readonly CheckDuplicatePath = '/pilots/exist';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `checkDuplicate()` instead.
   *
   * This method doesn't expect any request body.
   */
  checkDuplicate$Response(params: CheckDuplicate$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return checkDuplicate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `checkDuplicate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  checkDuplicate(params: CheckDuplicate$Params, context?: HttpContext): Observable<boolean> {
    return this.checkDuplicate$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `getActiveBpPilots()` */
  static readonly GetActiveBpPilotsPath = '/pilots/bp-pilots/{bpGuid}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getActiveBpPilots()` instead.
   *
   * This method doesn't expect any request body.
   */
  getActiveBpPilots$Response(params: GetActiveBpPilots$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BpPilot>>> {
    return getActiveBpPilots(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getActiveBpPilots$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getActiveBpPilots(params: GetActiveBpPilots$Params, context?: HttpContext): Observable<Array<BpPilot>> {
    return this.getActiveBpPilots$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<BpPilot>>): Array<BpPilot> => r.body)
    );
  }

}
